import { ObjectClass } from './../enums/object-class.enum';

export interface IObjectClass {
  value: ObjectClass;
  name: string;
  pluralName: string;
  parentClass?: string;
  content?: string;
  icon?: string;
  abr?: string;
  color?: string;
  searchable?: boolean;
}
